
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"79","height":"79"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Rectángulo 34","fill":"none","d":"M0 0h79v79H0z"}}),_c('path',{attrs:{"data-name":"Trazado 63","d":"M19 19.179A5.179 5.179 0 0124.179 14H44.9a2.589 2.589 0 011.83.758l12.944 12.948a2.59 2.59 0 01.759 1.831v31.074a5.179 5.179 0 01-5.179 5.179H24.179A5.179 5.179 0 0119 60.611zm35.181 10.358L44.9 20.251v9.286zM39.716 19.179H24.179v41.432h31.074v-25.9H42.306a2.59 2.59 0 01-2.59-2.59zM29.358 42.485a2.59 2.59 0 012.59-2.59h15.537a2.59 2.59 0 010 5.179H31.948a2.59 2.59 0 01-2.59-2.59m0 10.358a2.59 2.59 0 012.59-2.59h15.537a2.59 2.59 0 010 5.179H31.948a2.59 2.59 0 01-2.59-2.59","fill":"#6c757d"}})])
          )
        }
      }
    